import React from "react";
import style from "./Options.module.scss";
import { FormattedNumber } from "../../../../../FormattedNumber/FormattedNumber";

const Table = ({ rows, useOption }) => {
  if (Object.keys(rows).length == 0) {
    return <span style={{ textAlign: "center" }}>No options found it.</span>;
  }

  return (
    <div className={style.table}>
      <table>
        <thead>
          <tr>
            <th>Last</th>
            <th>Chg.</th>
            <th>Bid</th>
            <th>Ask</th>
            <th>Vol.</th>
            <th>Strike</th>
            <th>Last</th>
            <th>Chg.</th>
            <th>Bid</th>
            <th>Ask</th>
            <th>Vol.</th>
          </tr>
        </thead>
        <tbody>{Object.keys(rows).map((key) => buildRow({ key, r: rows[key], useOption }))}</tbody>
      </table>
    </div>
  );
};

const buildRow = ({ key, r, useOption }) => (
  <React.Fragment>
    <tr key={`opt-row-${key}`}>
      <td onClick={() => useOption(r.call)} className={style.link}>
        <NumericItem value={r.call.lastPrice} dataTypeDecimalName="price" />
      </td>
      <td>
        <NumericItem value={r.call.change} dataTypeDecimalName="currency" />
      </td>
      <td>
        <NumericItem value={r.call.bid} dataTypeDecimalName="currency" />
      </td>
      <td>
        <NumericItem value={r.call.ask} dataTypeDecimalName="currency" />
      </td>
      <td>
        <NumericItem value={r.call.volume} dataTypeDecimalName="currency" />
      </td>

      <td className={style.strike}>{key}</td>

      <td onClick={() => useOption(r.put)} className={style.link}>
        <NumericItem value={r.put.lastPrice} dataTypeDecimalName="price" />
      </td>
      <td className={style.put}>
        <NumericItem value={r.put.change} dataTypeDecimalName="currency" />
      </td>
      <td className={style.put}>
        <NumericItem value={r.put.bid} dataTypeDecimalName="currency" />
      </td>
      <td className={style.put}>
        <NumericItem value={r.put.ask} dataTypeDecimalName="currency" />
      </td>
      <td className={style.put}>
        <NumericItem value={r.put.volume} dataTypeDecimalName="currency" />
      </td>
    </tr>
  </React.Fragment>
);

const NumericItem = ({ value, dataTypeDecimalName }) => {
  if (value != undefined) {
    return <FormattedNumber value={value} dataTypeDecimalName={dataTypeDecimalName} />;
  }

  return "-";
};

export default Table;
